"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'JumpTo'
});
schema.propTypes = {
  items: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    label: _reactDesc.PropTypes.string.description('The text to be used as the button in the menu.').isRequired,
    offset: _reactDesc.PropTypes.number.description('A per item override of the primary offset value.'),
    selector: _reactDesc.PropTypes.string.description('A valid CSS selector for an element on the page.').isRequired
  })).description('An array of objects declaring menu items with their CSS selectors. `label` and `selector` values are required. The labels will be translated using the translation function set in the `ConfigProvider`.').isRequired,
  label: _reactDesc.PropTypes.string.description('An optional string that sets the label for the component. You can also set the label using the translations object set in context.').defaultValue('Jump To:'),
  offset: _reactDesc.PropTypes.number.description('A distance to offset the jump to target for _all_ selectors. Can be overridden when declaring jump to items.'),
  variant: _reactDesc.PropTypes.oneOf(['menu']).description("Selects a specific variation for display. If set to 'menu', the Jump To will display as a drop-down menu. If not set, will display using the standard horizontal layout."),
  zIndex: _reactDesc.PropTypes.number.description('For the nav variant, sets the z-index of the `<nav>` element. For the menu variant, sets the z-index of the Popover containing the menu items.'),
  openOnMouseHover: _reactDesc.PropTypes.bool.description('For the menu variant, if true, the menu will open on mouse hover. If false, the menu will open on mouse click.').defaultValue(false)
};
var _default = schema;
exports.default = _default;